const contactapi = [
    {
        id: "1",
        title: "Contact Us",
        subtitle: "We’d love to hear from you! Whether you have questions about our services, need assistance, or want to discuss a project, feel free to reach out.",

        heading:"Contact Us:",
        email: "hello@internetbusinesshub.com",
        phone:"+91 82838-74353",
        address: "2A, 1st Floor, Sarabha Nagar, Ludhiana, Punjab India - 141001",

        businessheading: "Business Hours:",
        text1: "Monday - Friday : 10 AM - 6 PM",
        text2: "Saturday: Closed",
        text3: "Sunday: Closed"
    }
]

export default contactapi